import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import EstimateDetailInvoice from './EstimateDetailInvoice';
import config from 'config.js';
import { useQuery } from 'react-query';

import StatusBadge from 'ui-component/StatusBadge';
import PdfViewer from 'ui-component/PdfViewer';


import { Skeleton } from '@mui/material';

import QoutationComponent from 'views/estimation/components/QoutationComponent';
import SalesOrderComponent from 'views/estimation/components/SalesOrderComponent';

import ClientTimeline from 'ui-component/ClientTimeline';
import useIsMobile from 'utils/isMobileUtils';

import usePageTitle from 'hooks/usePageTitle';

const InvoiceDetails = () => {
    const { id } = useParams();

    // Customer Create
    const [selectedEstimate, setSelectedEstimate] = useState();
    const [salesTypePath, setSalesTypePath] = useState('');
    const [salesType, setSalesType] = useState('');
    const [showActions, setShowActions] = useState(false);

    const currentDate = moment().format('YYYY-MM-DD');

    // End Create
    const history = useNavigate();

    const [shippingRow, setShippingrow] = useState({
        quantity: 1,
        unitPrice: 0,
        totalPrice: 0
    });

    const [selectedCustomerinfo, setSelectedCustomerInfo] = useState({});

    const location = useLocation();
    const pathParts = location.pathname.split('/');
    const [refreshKey, setRefreshKey] = useState(0);

    
    const queryParams = new URLSearchParams(location.search);


    const { data: requestData } = useQuery(
        ['client-invoice-details', id, location, salesTypePath, showActions, refreshKey],
        () => {
            const queryParams = new URLSearchParams(location.search);
            setShowActions(true);
            return api.getClientInvoiceDetails(id);
        },
        {
        }
    );

    // Row Area
    const [rows, setRows] = useState([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0 }]);


    //   End Row
    /* Shipping Calculator */


    useEffect(() => {
        initiateDatas();

        const subPath = pathParts;
        subPath.pop();

        setSalesTypePath(subPath.join('/'));

        setRefreshKey(oldKey => oldKey + 1);
    }, [location]);




    useEffect(() => {
        if (requestData?.data?.data) {
            // getSettings()
            setSelectedEstimate(requestData?.data?.data);
            if (salesTypePath == '/sales/estimates' || salesTypePath == '/sales/quotations') {
                setSalesType('estimate');
            } else {
                if (selectedEstimate?.invoice_number != '' && selectedEstimate?.estimation_number != '') {
                    setSalesType('invoice');
                } else {
                    setSalesType('credit-note');
                }
            }
            
        }
    }, [requestData]);

    const [defaultPageTitle, setDefaultPageTitle] = useState('');

    const [setPageTitle] = usePageTitle(defaultPageTitle); // Start with empty
    useEffect(() => {
        setDefaultPageTitle(salesType === 'invoice' ? 'Invoice' : salesType === 'estimate' ? 'Quotation' : '');
    }, [salesType]);
    
    const initiateDatas = () => {
        if (id) {
        } else {
            history(salesTypePath);
        }
    };


    useEffect(() => {
        if (selectedEstimate) {
            const expDate = moment(selectedEstimate?.expires_at).format('YYYY-MM-DD');
            let tempRow = selectedEstimate?.estimation_details.map((item, index) => {
                return {
                    id: index,
                    modelId: item?.product_id,
                    type: item?.product?.product_name,
                    quantity: item?.qty,
                    unitPrice: Number(item?.unit_price),
                    total: item?.total_price
                };
            });

            tempRow = [
                ...tempRow,
                {
                    id: tempRow.length + 1,
                    modelId: '',
                    type: '',
                    quantity: '',
                    unitPrice: '',
                    total: ''
                }
            ];

            setRows(tempRow);
            setSelectedCustomerInfo(selectedEstimate.customer);

            const temEstimate = {
                estimate_number: selectedEstimate?.estimation_number,
                customer_id: selectedEstimate?.customer_id,
                startDate: selectedEstimate?.start_date,
                expiryDate: expDate,
                transit_id: selectedEstimate?.transit_company?.id,
                sales_manager: selectedEstimate?.sales_person?.id,
                private_note: selectedEstimate?.private_note,
                vatStatus: selectedEstimate?.vat_type,
                vatPrice: selectedEstimate?.vat_percent || 21,
                currency: selectedEstimate?.currency,
                private_note: selectedEstimate?.private_note,
                expiresIn: moment(selectedEstimate?.expires_at).diff(selectedEstimate?.start_date, 'days')
            };

            let notesArray = [];

            selectedEstimate?.notes?.forEach((note) => {
                notesArray = [
                    {
                        id: note?.id,
                        details: note?.details,
                        date: moment(note?.created_at).format('YYYY-MM-DD'),
                        time: moment(note?.created_at).format('HH:mm'),
                        user_name: `${note?.user_created?.first_name} ${note?.user_created?.last_name}`,
                        expand: false,
                        isDeletable: note?.is_deletable
                    },
                    ...notesArray
                ];
            });

            notesArray = _.sortBy(notesArray, (n) => -n.id);

            const tempShipping = {
                unitPrice: selectedEstimate?.shipping_fees,
                quantity: selectedEstimate?.shipping_qty,
                totalPrice: Number(selectedEstimate?.shipping_fees) * Number(selectedEstimate?.shipping_qty)
            };
        }
    }, [selectedEstimate]);


    const isMobile = useIsMobile();


    return (
        <div className="row m-0 w-100 est-nv-container">
            <div className="col-12 col-md-8 offset-md-2 p-0 p-md-2 inv-preview">
                <div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
                    <div className="client-header-bubble" />
                    <div className="d-flex flex-column gap-2 mb-4" style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
                        <div
                            style={{
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: 8,
                                minHeight: 38 // ensures enough height for the button
                            }}
                        >
                            {' '}
                            <button
                                type="button"
                                aria-label="Back"
                                onClick={() => history(-1)}
                                className="circle-back-btn"
                                style={{
                                    position: 'absolute',
                                    left: 20,
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }}
                            >
                                {/* Replace with your fi arrow icon, example below */}
                                <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                                    <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                <h5 style={{ textAlign: 'center', flex: 1, margin: 0, whiteSpace: 'nowrap' }}>Invoice {selectedEstimate?.invoice_number}</h5>
                                <StatusBadge itemStatus={selectedEstimate?.master_status?.name} />
                            </div>
                        </div>

                    
                    </div>
                </div>
                <div className="section-head-new pl-0 mb-1 mt-2 hide-on-mobile">
                </div>
                <div className="row hide-on-mobile">
                    <div className="col-12">
                        {!selectedEstimate ? (
                            <div style={{ marginTop: '-7px', marginBottom: '10.2px' }}>
                                <Skeleton variant="rounded" width={'100%'} height={160} style={{ borderRadius: '12px' }} />
                            </div>
                        ) : (
                            selectedEstimate?.is_credit_note !== 1 && (
                                salesType === 'invoice' && selectedEstimate?.master_status?.name !== 'Draft' && (
                                    <div>
                                        <ClientTimeline
                                            id={selectedEstimate?.id}
                                            source={'invoice'}
                                        />
                                    </div>
                                )
                            )
                        )}
                    </div>
                </div>
                <div className="row m-0 mobile-scroll-container">
                    <div className="show-on-mobile" style={{ width: '100%', display: 'flex' }}>
                        {!selectedEstimate ? (
                            <div style={{ width: '100%', marginBottom: '8px' }}>
                                <Skeleton variant="rounded" width={'100%'} height={34} style={{ borderRadius: '12px' }}></Skeleton>
                            </div>
                        ) : (
                            selectedEstimate?.is_credit_note !== 1 && (
                                salesType === 'invoice' && selectedEstimate?.master_status?.name !== 'Draft' && (
                                    <div style={{ width: '100%', marginBottom: '8px', paddingTop: 10 }}>
                                        
                                        <ClientTimeline
                                            id={selectedEstimate?.id}
                                            source={'invoice'}
                                        />
                                    </div>
                                )
                            )
                        )}
                    </div>
                    <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                        <EstimateDetailInvoice estimate={selectedEstimate} modulePath={salesTypePath} viewedBy={`CLIENT`} />
                        {!isMobile && (
                            <>
                                {salesType === 'invoice' && selectedEstimate?.qoutation?.id && <QoutationComponent details={selectedEstimate} viewedBy="CLIENT" />}
                                {selectedEstimate?.sales_order?.id && <SalesOrderComponent details={selectedEstimate} viewedBy="CLIENT" />}
                            </>
                        )}
                    </div>
                    {isMobile && (
                        <>
                            {salesType === 'invoice' && selectedEstimate?.qoutation?.id && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <QoutationComponent details={selectedEstimate} viewedBy="CLIENT" />
                                </div>
                            )}
                            {selectedEstimate?.sales_order?.id && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <SalesOrderComponent details={selectedEstimate} viewedBy="CLIENT" />
                                </div>
                            )}
                        </>
                    )}
                    
                    {(selectedEstimate?.master_status?.name !== 'Draft' && salesType !== 'estimate') && (
                        <div className="mb-3 w-100">
                            {
                                !selectedEstimate ? (
                                    <div>
                                        <Skeleton variant="rounded" width={'100%'} height={75} style={{ borderRadius: '12px' }} />
                                    </div>
                                ) : (
                                    selectedEstimate?.attachments?.length > 0 && (
                                        selectedEstimate?.attachments?.map((attachment, index) => (
                                            <div className="row m-0" key={index}>
                                                <div className="col-12" style={{ padding: '0' }}>
                                                    <div className="card shadow-sm bg-white mb-4 w-100 border card-border-gray">
                                                        <div className="card-header-radius-0" style={{ padding: '0px 10px' }}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="section-head row" style={{ padding: '0px 10px !important', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                                                                        <div style={{ marginTop: '-4px', alignItems: 'center', fontSize: '14px', padding: '8px 0' }} className="col-md-12">
                                                                            {attachment?.filename}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-body text-center" style={{ padding: '0px' }}>
                                                            {attachment?.extension == 'pdf' ? (
                                                                <PdfViewer src={attachment?.attachment_url + '#toolbar=0&navpanes=0&zoom=FitW'} />
                                                            ) : (
                                                                // <PdfViewer src={'https://mixglobalapi.projectmix.ai/storage/uploads/purchase_invoices/2/Purchase-Invoice-PO25002-1746620742.pdf#toolbar=0&navpanes=0&zoom=FitW'} />
                                                                // <PdfViewer src={'https://mgappapi.projectmix.ai/storage/uploads/purchase_invoices/161/Purchase-Invoice-PO24160-1735895437.pdf#toolbar=0&navpanes=0&zoom=FitW'} />
                                                                <img src={attachment?.attachment_url} className="img-fluid" />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )
                                )
                            }
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default InvoiceDetails;
